import { LicensePlan } from '../../types';

export const m365EducationPlans: LicensePlan[] = [
  {
    id: 'm365-a1',
    name: 'Microsoft 365 A1',
    description: 'Free for qualifying educational institutions',
    pricing: {
      points: [
        { amount: null, currency: 'USD', unit: 'user/month', effective: '1970-01-01', label: 'Free' }
      ]
    },
    features: [
      { name: 'Exchange Online', included: true, additionalInfo: '50 GB mailbox' },
      { name: 'SharePoint Online', included: true },
      { name: 'Microsoft Teams', included: true },
      { name: 'Web versions of Office', included: true },
      { name: 'OneDrive for Business', included: true, additionalInfo: '1 TB storage' },
      { name: 'Basic Security', included: true },
      { name: 'School Data Sync', included: true },
      { name: 'Microsoft Forms', included: true },
      { name: 'Stream', included: true },
      { name: 'Sway', included: true },
    ]
  },
  {
    id: 'm365-a3',
    name: 'Microsoft 365 A3',
    description: 'Desktop apps and advanced security for education',
    pricing: {
      points: [
        { amount: 3.25, currency: 'USD', unit: 'user/month', effective: '1970-01-01', audience: 'student' },
        { amount: 6.0, currency: 'USD', unit: 'user/month', effective: '1970-01-01', audience: 'faculty' }
      ]
    },
    features: [
      { name: 'Exchange Online', included: true, additionalInfo: '100 GB mailbox' },
      { name: 'SharePoint Online', included: true },
      { name: 'Microsoft Teams', included: true },
      { name: 'Desktop Office apps', included: true },
      { name: 'OneDrive for Business', included: true, additionalInfo: 'Unlimited storage' },
      { name: 'Microsoft Entra ID P1', included: true },
      { name: 'Microsoft Intune', included: true },
      { name: 'School Data Sync', included: true },
      { name: 'Microsoft Forms', included: true },
      { name: 'Stream', included: true },
      { name: 'Sway', included: true },
      { name: 'Intune for Education', included: true },
      { name: 'Azure Information Protection P1', included: true },
    ]
  },
  {
    id: 'm365-a5',
    name: 'Microsoft 365 A5',
    description: 'Advanced security, compliance, and analytics for education',
    pricing: {
      points: [
        { amount: 8.0, currency: 'USD', unit: 'user/month', effective: '1970-01-01', audience: 'student' },
        { amount: 12.0, currency: 'USD', unit: 'user/month', effective: '1970-01-01', audience: 'faculty' }
      ]
    },
    features: [
      { name: 'Exchange Online', included: true, additionalInfo: 'Unlimited archive' },
      { name: 'SharePoint Online', included: true },
      { name: 'Microsoft Teams', included: true },
      { name: 'Desktop Office apps', included: true },
      { name: 'OneDrive for Business', included: true, additionalInfo: 'Unlimited storage' },
      { name: 'Microsoft Entra ID P2', included: true },
      { name: 'Microsoft Intune', included: true },
      { name: 'School Data Sync', included: true },
      { name: 'Microsoft Forms', included: true },
      { name: 'Stream', included: true },
      { name: 'Sway', included: true },
      { name: 'Intune for Education', included: true },
      { name: 'Azure Information Protection P2', included: true },
      { name: 'Microsoft Defender for Office 365 P2', included: true },
      { name: 'Power BI Pro', included: true },
      { name: 'Phone System', included: true },
      { name: 'Audio Conferencing', included: true },
    ]
  }
];